import { saveDiscount } from 'redux/discounts'
import { confirmationModal } from 'redux/navigation'
import React from 'react'
import { Field, getFormSyncErrors, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { Grid, Header, Segment, Table } from 'semantic-ui-react'
import DiscountName from './DiscountName'
import { CHF, classNames } from 'lib/utilities'
import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import getActions from './getActions'
import DiscountDates from './DiscountDates'
import moment from 'moment'
import { FormInput, validateNumbers, validateRequired } from 'components/shared/Forms/ReduxForm'
import NavigationLink from '../../shared/Navigation/renditions/NavigationLink'

const i18nkey = 'admin.discounts.details.'

const mapStateToProps = (state) => {
  const { discountsLoading, discounts } = state.discounts
  const { customerOrders = {} } = state.carts
  return {
    discountsLoading,
    discounts,
    customerOrders: customerOrders.carts || [],
    errors: getFormSyncErrors('discount_details')(state),
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ saveDiscount, confirmationModal }, dispatch)

class CreditDetails extends React.Component {
  initForm(discounts, discount_id) {
    const { initialize, destroy } = this.props
    console.log(discount_id)
    if (discount_id === '+credit') {
      const valid_from = moment()
        .startOf('day')
        .format()
      const valid_until = moment()
        .startOf('day')
        .add(1, 'year')
        .format()
      initialize({
        valid_from,
        kind: 'credit',
        valid_until,
        user_id: 1,
        dealers_only: false,
      })
    } else {
      const currentDiscount = discounts.find((d) => d.id === +discount_id)
      if (currentDiscount) {
        initialize(currentDiscount)
      } else {
        destroy()
      }
    }
  }

  componentWillMount() {
    const { discounts } = this.props
    const discount_id = this.props.match.params.discount_id
    this.initForm(discounts, discount_id)
  }

  componentWillReceiveProps(nextProps) {
    const { discounts: newDiscounts } = nextProps
    const { discounts: oldDiscounts, initialized } = this.props
    const newDiscountId = nextProps.match.params.discount_id
    const oldDiscountId = this.props.match.params.discount_id
    if (
      (newDiscounts &&
        oldDiscounts &&
        newDiscounts.length !== oldDiscounts.length) ||
      newDiscountId !== oldDiscountId ||
      !initialized
    )
      this.initForm(newDiscounts, newDiscountId)
  }
  render() {
    const { initialized, customerOrders, discounts } = this.props
    const discount_id = +this.props.match.params.discount_id
    const currentDiscount = discounts.find((d) => d.id === +discount_id)
    const hasUsages =
      currentDiscount &&
      Array.isArray(currentDiscount.used) &&
      currentDiscount.used.length > 0
    const dark = config.theme.dark
    const title = discount_id
      ? I18n.t(i18nkey + 'edit_credit')
      : I18n.t(i18nkey + 'new_credit')
    const code_title = discount_id
      ? I18n.t(i18nkey + 'edit_code')
      : I18n.t(i18nkey + 'new_code')
    const value_title = hasUsages
      ? I18n.t(i18nkey + 'edit_credit_value')
      : I18n.t(i18nkey + 'new_credit_value')
    if (!initialized) {
      return <pre>Not initialized"</pre>
      // return <ComponentPlaceholder title={title} inactive loading={false} />
    }
    return (
      <div
        className={classNames([
          'discountDetails',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader title={title} customActions={getActions(this.props)} />
        <Segment attached className={classNames([dark && 'inverted'])}>
          <Grid stackable>
            <DiscountName />
            <Grid.Row>
              <Grid.Column width={6}>
                <Field
                  component={FormInput}
                  validate={[validateNumbers, validateRequired]}
                  name="value"
                  readOnly={hasUsages}
                  label={value_title}
                  placeholder={I18n.t(i18nkey + 'value_placeholder')}
                  required
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Field
                  name="auto_code"
                  readOnly
                  component={FormInput}
                  label={code_title}
                />
              </Grid.Column>
            </Grid.Row>
            <DiscountDates />
            {hasUsages && (
              <Grid.Row>
                <Grid.Column width={12}>
                  <Header children={I18n.t(i18nkey + 'usages')} />
                  <Table compact size="small" singleLine basic="very">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell children={I18n.t(i18nkey + 'date')} />
                        <Table.HeaderCell
                          children={I18n.t(i18nkey + 'customer_name')}
                        />
                        <Table.HeaderCell
                          children={I18n.t(i18nkey + 'order')}
                        />
                        <Table.HeaderCell
                          children={I18n.t(i18nkey + 'previous_value')}
                        />
                        <Table.HeaderCell
                          children={I18n.t(i18nkey + 'new_value')}
                        />
                      </Table.Row>
                    </Table.Header>
                    {hasUsages &&
                      [...currentDiscount.used].reverse().map((u, i) => {
                        const order = customerOrders.find(
                          (o) => o.id === u.cart_id
                        )
                        const finalized_at =
                          order &&
                          new Date(order.data.finalized_at).toLocaleDateString(
                            'de-CH',
                            config.format.date
                          )
                        const name = (
                          ((order || {}).data || {}).billing_address || {}
                        ).address_1
                        return (
                          <Table.Row key={i}>
                            <Table.Cell children={finalized_at} />
                            <Table.Cell children={name} />
                            <Table.Cell>
                              {u.cart_id && (
                                <NavigationLink
                                  item={{
                                    path:
                                      config.nodes.customer_order + u.cart_id,
                                  }}
                                  children={u.cart_id}
                                />
                              )}
                            </Table.Cell>
                            <Table.Cell children={CHF(u.previous_value)} />
                            <Table.Cell children={CHF(u.new_value)} />
                          </Table.Row>
                        )
                      })}
                  </Table>
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </Segment>
      </div>
    )
  }
}

CreditDetails = connect(mapStateToProps, mapDispatchToProps)(CreditDetails)
CreditDetails = reduxForm({ form: 'discount_details' })(CreditDetails)
export default withRouter(CreditDetails)



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/CreditDetails.jsx